import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { Paper, Divider } from "@material-ui/core";
import { UnassignedPickupsMarker } from "../../../../../mapComponents/Markers";
import {compose} from 'recompose';
import PlannedRouteMarker from "../../../../Reports/NextStopCompliance/NextStopComplianceMap/Legend/LegendMarker/PlannedRouteMarker";
import ActualRouteMarker from "../../../../../mapComponents/Markers/NextStopCompliance/ActualRouteMarker";

const styles = (theme) => ({
  outerMostWrapper: {
    zIndex: 2,
    position: "absolute",
    pointerEvents: "auto",
    bottom: 0,
    left: 5,
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ModalBGColor,
  },
  detailsContainer: {
    position: "absolute",
    top: "10%",
    left: "12%",
  },
  legendHeader: {
    color: theme.palette.primary.main,
    fontSize: "14px",
    height: 25,
    padding: 10,
    fontWeight: 600,
    textAlign: "left",
    display: "flex",
  },
  legendDetailsContainer: {
    display: "flex",
    justifyContent: "flex-start",
    padding: 1,
  },
  details: {
    display: "flex",
    alignItems: "center",
    columnGap: 5,
    padding: 10,
    width: 125,
  },
  detailsLabel: {
    color: theme.ModalHeaderTextColor,
    fontSize: 10,
    marginLeft: 5,
    marginRight: 5,
  },
  iconContainer: {
    width: 24,
    height: 24,
    marginLeft: -2,
  },
  pickupContainer: {
    width: 22,
    height: 22,
    backgroundColor: theme.palette.primary.main,
  },
  deliveryContainer: {
    width: 22,
    height: 22,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 11,
  },
  divider: {
    background: theme.gridIconBorderColor,
    height: 0.5,
  },
});
class MapLegend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: this.props.defaultVisible,
    };
  }

  componentDidMount() {
    this.props.glEventHub.on("mapLegend", this.updateVisibility);
  }

  componentWillUnmount() {
    this.props.glEventHub.off("mapLegend", this.updateVisibility);
  }

  updateVisibility = (isVisible) => {
    this.setState({
      isVisible: isVisible,
    });
  };
  render() {
    const { classes, theme, enableDriverActualRoute } = this.props;
    if(!this.state.isVisible){
      return null
    }
    return (
      <Paper className={classes.outerMostWrapper}>
        <div>
          <div id="legendHeadeer" className={classes.legendHeader}>
            Map Legend
          </div>
          <Divider className={classes.divider} />
          <div id="legendDetails" className={classes.legendDetailsContainer}>
            <div className={classes.details}>
              <div className={classes.iconContainer}>
                <UnassignedPickupsMarker
                  backgroundColor={theme.unassignPickupFillColor}
                  borderColor={theme.markerStokeColor}
                />
              </div>
              <div className={classes.detailsLabel}>Unassigned Pickup</div>
            </div>
            <div className={classes.details}>
              <div className={classes.pickupContainer}></div>
              <div className={classes.detailsLabel}>Pickup</div>
            </div>
            <div className={classes.details}>
              <div className={classes.deliveryContainer}></div>
              <div className={classes.detailsLabel}>Delivery</div>
            </div>
          </div>
          <div id="legendDetails2" className={classes.legendDetailsContainer}>
            <div className={classes.details}>
              <PlannedRouteMarker color={theme.palette.primary.main}/>
              <div className={classes.detailsLabel}>Planned Route</div>
            </div>
            {enableDriverActualRoute && <div className={classes.details}>
              <ActualRouteMarker color={theme.actualRouteColor} />
              <div className={classes.detailsLabel}>Actual Route</div>
            </div>}
          </div>
        </div>
      </Paper>
    );
  }
}

export default compose(withStyles(styles), withTheme())(MapLegend);
